export default "__VITE_ASSET__6774fb53__"